export const FETCH_LOGS = 'FETCH_LOGS'